const NewToDoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99994 15L10.9999 17L14.9999 13M12.9999 3.00087C12.9044 3 12.7972 3 12.6746 3H8.20015C7.08006 3 6.5196 3 6.09178 3.21799C5.71546 3.40973 5.40973 3.71547 5.21798 4.0918C5 4.51962 5 5.08009 5 6.20019V17.8002C5 18.9203 5 19.4801 5.21798 19.9079C5.40973 20.2842 5.71546 20.5905 6.09178 20.7822C6.51918 21 7.07898 21 8.1969 21L15.8029 21C16.9208 21 17.4798 21 17.9072 20.7822C18.2835 20.5905 18.5903 20.2842 18.782 19.9079C18.9998 19.4805 18.9998 18.9215 18.9998 17.8036V9.32568C18.9998 9.20296 18.9998 9.09561 18.9989 9M12.9999 3.00087C13.2855 3.00347 13.4662 3.01385 13.6387 3.05526C13.8428 3.10425 14.0377 3.18526 14.2167 3.29492C14.4184 3.41857 14.5917 3.59182 14.9374 3.9375L18.0628 7.06298C18.4087 7.40889 18.5807 7.58136 18.7044 7.78319C18.814 7.96214 18.8951 8.15726 18.9441 8.36133C18.9855 8.53376 18.9962 8.71451 18.9989 9M12.9999 3.00087V5.8C12.9999 6.9201 12.9999 7.47977 13.2179 7.90759C13.4096 8.28391 13.7154 8.59048 14.0917 8.78223C14.5191 9 15.0789 9 16.1968 9H18.9989M18.9989 9H19"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewToDoIcon;
